import axios from 'axios';

const normalizeApiUrl = (rawUrl?: string) => {
  const fallback = 'https://astweb.ultrakerb.cloud/api/';
  const base = (rawUrl || fallback).trim();

  if (/\/api\/?$/i.test(base)) {
    return base.endsWith('/') ? base : `${base}/`;
  }

  return base.endsWith('/') ? `${base}api/` : `${base}/api/`;
};

const API_URL = normalizeApiUrl(import.meta.env.VITE_API_URL as string | undefined);

const api = axios.create({
  baseURL: API_URL,
});

const inFlightGetRequests = new Map<string, Promise<any>>();

const originalGet = api.get.bind(api);
api.get = ((url, config = {}) => {
  const dedupeKey = JSON.stringify({
    url,
    params: config.params || null,
    auth: (config.headers as Record<string, string> | undefined)?.Authorization || null,
  });

  if (inFlightGetRequests.has(dedupeKey)) {
    return inFlightGetRequests.get(dedupeKey) as Promise<any>;
  }

  const requestPromise = originalGet(url, config).finally(() => {
    inFlightGetRequests.delete(dedupeKey);
  });

  inFlightGetRequests.set(dedupeKey, requestPromise);
  return requestPromise;
}) as typeof api.get;

export default api;
